<template>
    <div class="clearifx" v-model="loading" :data-loading="loading">
        <!--<gambling-loader :loading="loading"></gambling-loader>-->
        <div class="clearfix row">
            <div class="col-sm-6 col-lg-4">
                <div class="mb-4">
                    <label for="payments" class="p-0 mb-2">SELECT PAYMENT</label>
                    <select
                        name="payments"
                        id="payments"
                        class="select-box-large select2"
                        v-model="provider"
                        data-width="100%"
                        @change="updateProviders"
                    >
                        <option v-for="(item, index) in providersList" :value="item.value">
                            {{ item.label }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table id="table-payments" class="table table-content">
                <thead class="thead-light">
                    <tr>
                        <th>GAMBLING SITE</th>
                        <th>DEPOSIT</th>
                        <th>WITHDRAWAL</th>
                        <th>PROCESSING TIME</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(item, key) in filteredList"
                        v-model="filteredList"
                        :key="key"
                        :data-provider="item.brand_name.toLowerCase()"
                        :data-brand-id="item.brand_product_id"
                    >
                        <td>{{ item.brand_product_name }}</td>
                        <td>
                            <span
                                class="ml-2"
                                v-html="checkMarkLabel(item.current_feature.deposit_allowed)"
                            ></span>
                        </td>
                        <td>
                            <span
                                class="ml-2"
                                v-html="checkMarkLabel(item.current_feature.withdrawal_allowed)"
                            ></span>
                        </td>
                        <td>
                            <div
                                class="d-flex align-items-center h-100"
                                v-html="processingTime(item.current_feature.withdraw_time)"
                            ></div>
                        </td>
                        <td v-html="link(item)"></td>
                    </tr>
                    <tr class="no-data" v-if="filteredList.length === 0 && providerName !== null">
                        <td colspan="5">
                            <div class="p-2 w-100 d-flex align-items-center">
                                <span
                                    >No casinos currently offering {{ providerName }}. Check back
                                    soon.</span
                                >
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { PaymentProvidersFilter } from '../PaymentProvidersFilter';

const providerFilter = new PaymentProvidersFilter();

export default {
    mounted() {
        let self = this;

        self.setInitialProvider(self.list_providers.default);
        self.setProvidersList(self.list_providers.list);
        self.setProductsList(self.list_products);
        self.select2Listener();

        self.updateProviders();
    },
    props: ['list_products', 'list_providers'],

    data: function () {
        return {
            providersList: [],
            productsList: [],
            filteredList: [],
            loading: false,
            provider: null,
            providerName: null,
        };
    },
    methods: {
        select2Listener() {
            let self = this;
            $('select#payments')
                .select2()
                .on('select2:select', (e) => {
                    self.provider = $(e.currentTarget).val();
                    self.updateProviders();
                });
        },
        setFilteredList(list) {
            this.filteredList = list;
        },
        setProductsList(list) {
            this.productsList = list;
        },
        setProvidersList(list) {
            this.providersList = list;
        },
        setInitialProvider(provider) {
            this.provider = provider;
        },
        setProviderName(provider) {
            let self = this;
            this.providersList.forEach(function (item) {
                if (item.value === provider) {
                    self.providerName = item.dataName;
                    return false;
                }
            });
        },
        updateProviders() {
            let self = this;

            self.loading = true;

            self.setProviderName(self.provider);

            let filter = providerFilter
                .setData(self.productsList)
                .filterByRelatedFeatureName(self.provider)
                .limit(20)
                .getFilteredData();
            filter.then(function (response) {
                self.loading = false;
                self.filteredList = response;
            });
        },
        link(item) {
            return (
                '<a href="' +
                item.link +
                '" class="automation-read-review review-link d-flex align-items-center justify-content-center h-100">' +
                item.brand_name +
                ' review »' +
                '</a>'
            );
        },
        checkMarkClass(state) {
            let classes = ['d-flex', 'align-items-center', 'justify-content-center'];
            if (state) {
                classes.push('checkmark-true');
            } else {
                classes.push('checkmark-false');
            }
            return classes.join(' ');
        },
        checkMarkIcon(state) {
            return state
                ? '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="#000" d="M 6 14.023438 L 0 8.265625 L 1.859375 6.351562 L 5.964844 10.265625 L 14.105469 1.976562 L 16 3.855469 Z M 6 14.023438"/></svg>'
                : '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="#000" d="M 15.96875 14.019531 L 9.847656 7.957031 L 15.90625 1.839844 L 14.019531 -0.03125 L 7.960938 6.089844 L 1.84375 0.03125 L -0.03125 1.902344 L 6.09375 7.972656 L 0.03125 14.097656 L 1.902344 15.96875 L 7.976562 9.839844 L 14.097656 15.90625 Z M 15.96875 14.019531"/></svg>';
        },
        checkMarkLabel(state) {
            if (state) {
                return 'Yes';
            } else {
                return 'No';
            }
        },
        processingTime(time) {
            if (time === '') {
                return 'No Withdrawal time';
            }
            return time;
        },
    },
};
</script>
